import React from 'react';
import { Link as LinkS } from 'react-scroll';
import showimage from '../../images/showimage.jpg';
import './Showcase.css';

const Showcase = () => {
    return (
        <div className='showcase' id='showcase' style={{
            backgroundImage: `url(${showimage})`,
            backgroundSize: 'cover', backgroundPosition: 'center center'
        }}>
            <div className='showcase__contents'>
                <div className='showcase__title'>Professional IT Solution Consulting</div>
                <div className='showcase__description'>Since our establishment we have been delivering high-quality and sustainable IT solutions for corporate business purpose</div>
                <div className='showcase__buttons'>
                    <button className='showcase__button hide'><LinkS to='about' smooth={true} duration={1000}>Discover More</LinkS></button>
                    <button className='showcase__button show'><a href='tel:+250780257333'>Get in Touch</a></button>
                </div>
            </div>

            {/* <div className='showcase__arrow'>
                <LinkS to='about' smooth={true} duration={1000}><i className='fas fa-arrow-circle-down'></i></LinkS>
            </div> */}
        </div >
    )
}

export default Showcase
